import { Component, Input } from '@angular/core';
import { ElectricityInvoice, GasInvoice, InvoiceElectricityAndCompanyGet, InvoiceGasAndCompanyGet, InvoiceStatus, VisibilityStatus } from '../../../../core/interfaces/invoice-interfaces';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { InvoiceHelperService } from '../../../../core/services/invoice-helper.service';

@Component({
  selector: 'app-admin-invoice-status-text',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './admin-invoice-status-text.component.html',
  styleUrl: './admin-invoice-status-text.component.css'
})
export class AdminInvoiceStatusTextComponent {
  constructor(private invoiceHelperService: InvoiceHelperService) { }

  InvoiceStatus = InvoiceStatus;
  VisibilityStatus = VisibilityStatus;

  @Input() invoiceStatus: InvoiceStatus = InvoiceStatus.ERROR;
  @Input() visibilityStatus: VisibilityStatus = VisibilityStatus.READY_FOR_USER;
  @Input() reviewRequested: boolean = false;
  @Input() adminApproved: boolean = false;
  @Input() electricityInvoice: ElectricityInvoice | InvoiceElectricityAndCompanyGet | null = null;
  @Input() gasInvoice: GasInvoice | InvoiceGasAndCompanyGet | null = null;

  get disputeReasonsSummary(): string {
    if (this.electricityInvoice) {
      return this.invoiceHelperService.getElectricityDisputeReasonsSummary(this.electricityInvoice);
    }
    if (this.gasInvoice) {
      return this.invoiceHelperService.getGasDisputeReasonsSummary(this.gasInvoice);
    }
    return '';
  }

  get isSpreadMissing(): boolean {
    if (this.electricityInvoice == null) {
      return this.invoiceStatus !== InvoiceStatus.IN_DISPUTED && this.visibilityStatus === VisibilityStatus.UNDER_SILENT_ADMIN_REVIEW
    }
    return this.invoiceHelperService.isSpreadMissing(this.electricityInvoice);
  }
}
